import React, { Component } from "react";
import moment from "moment";

import { cards } from "constants/cards";
import { isUndefined } from "util";

import { Input, Checkbox, Spin, Icon } from "antd";
import { Card } from "components";

import { selectService } from "services";

// Composant qui render une liste de Cards.
// Fetch selon le type donnée et les infos appropriées dans constants/cards.
// Implémente une recherche.
class CardsList extends Component {
  constructor(props) {
    super(props);
    this._isMounted = true;
    this.state = {
      filters: {},
      controller: null,
      data: [],
      display: [],
      loading: true,
    };
  }

  componentDidMount() {
    const { type } = this.props;
    const controller = cards[type];
    // Setup des filtres prédéfinis
    const filters = {
      ...JSON.parse(localStorage.getItem(`filters[cards][${type}]`)),
      ...controller.filtersDefaultValue,
    };
    this.setState({ controller, filters }, () => this.fetchData());
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  fetchData() {
    const { controller } = this.state;
    const fixedFilters = { ...this.props.filters };

    if (this.state?.filters?.lastWeek === true)
      fixedFilters["date"] = [
        moment().subtract(1, "weeks").format("YYYY-MM-DD"),
        moment().add(1, "day").format("YYYY-MM-DD"),
      ];

    const fetcher = "func" in controller ? controller.func : "list";

    this.setState({ loading: true }, () => {
      controller.service[fetcher](fixedFilters)
        .then((result) => {
          if (!this._isMounted) return;
          if (result && "page" in result) result = result.data;
          if (controller.preSort) result = controller.preSort(result);

          this.setState({ data: result, display: result, loading: false }, () => {
            this.handleSearch();
          });
        })
        .catch((e) => {
          if (!this._isMounted) return;
          this.setState(() => {
            throw new Error(e);
          });
        });
    });
  }

  handleFilterChange(key, value) {
    this.setState({ filters: { ...this.state.filters, [key]: value } }, () => {
      const { type } = this.props;
      localStorage.setItem(`filters[cards][${type}]`, JSON.stringify({ ...this.state.filters }));

      if (key === "lastWeek") this.fetchData();
      else this.handleSearch();
    });
  }

  handleSearch() {
    const { type } = this.props;
    const { data, controller, filters } = this.state;
    const { searchFields } = controller;

    let results = data;

    const query = this.state.filters.query || "";
    if (query === "") {
      this.setState({ display: results });
      return;
    }

    const matches = (value) => value.toLowerCase().indexOf(query.toLowerCase()) >= 0;
    results = results.filter((d) => {
      var match = false;
      for (var field of searchFields) {
        if (field.indexOf(".") !== -1) {
          var params = field.split(".");
          var value = d;
          params.map((param, i) => {
            value = value[param];

            if (i === params.length - 1) {
              if (matches(value)) match = true;
            }
          });
        } else {
          if (matches(d[field])) match = true;
        }
      }

      return match;
    });

    this.setState({ display: results });
  }

  compare(a, b) {
    const dateA = a.tailgate ? a.tailgate.date : 0;
    const dateB = b.tailgate ? b.tailgate.date : 0;
    if (dateA < dateB) {
      return 1;
    }
    if (dateA > dateB) {
      return -1;
    }
    return 0;
  }

  render() {
    const { type, tv } = this.props;
    let { controller, display, filters, loading } = this.state;
    if (type == "home" && display.length > 0) {
      display = display.sort(this.compare);
    }
    if (!controller) return <></>;

    return (
      <div className="cards-list-wrap">
        {controller.filter && !tv && (
          <div className="cards-filters">
            <Input.Search
              allowClear
              onChange={(e) => this.handleFilterChange("query", e.target.value)}
              value={filters.query}
            />
          </div>
        )}

        {controller.lastWeekFilter && !tv && (
          <Checkbox
            onChange={(e) => this.handleFilterChange("lastWeek", e.target.checked)}
            checked={filters.lastWeek}
          >
            Dernière semaine uniquement
          </Checkbox>
        )}
        <Spin
          indicator={<Icon type="loading" spin style={{ color: "white", fontSize: "32px" }} />}
          spinning={loading}
        >
          <div className="cards-list">
            {display && display.length > 0 ? (
              display.map((d, i) => <Card key={i} content={controller.generateCard(d)} />)
            ) : (
              <p className="empty-message">Aucun résultat...</p>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}

export default CardsList;
